import React from 'react'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SvgIcon from '@mui/material/SvgIcon'
import Search from '@tdcerhverv/parrotfish/dist/icons/Icons/Search.svg'
import { grey } from '@mui/material/colors'
import { useTheme } from '@mui/material/styles'

const SearchField: React.FC<{
  onSearchTextChanged: (searchText: string) => void
}> = ({ onSearchTextChanged }) => {
  const [searchText, setSearchText] = React.useState('')
  const { palette } = useTheme()
  const styles = {
    searchField: {
      '& .MuiInputBase-root': {
        backgroundColor: palette.common.white,
      },
      '& fieldset': {
        border: `1px solid ${grey[400]}`,
      },
    },
  }
  const onChangeSearchText = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const searchText = event.target.value
      onSearchTextChanged(searchText)
      setSearchText(searchText)
    },
    [onSearchTextChanged, setSearchText],
  )

  return (
    <TextField
      onChange={onChangeSearchText}
      sx={styles.searchField}
      variant="outlined"
      value={searchText}
      placeholder="søg"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SvgIcon fontSize="inherit" component={Search} viewBox="0 0 48 48" />
          </InputAdornment>
        ),
      }}
    />
  )
}

export default SearchField
